import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
} from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { Subscription } from "rxjs";
import { AuthService } from "src/app/core/service/auth.service";
import { RestClientService } from "src/app/core/service/rest-client.service";
import { UtilitiesService } from "src/app/core/service/utilities.service";
import Swal from "sweetalert2";
import * as _ from "lodash";
import * as moment from "moment";
import { ModalViewreseauDeSoinDetailComponent } from "../modal-view-reseau-soin-detail/modal-view-reseau-soin-detail.component";

@Component({
  selector: "app-modal-view-souscripteur-detail",
  templateUrl: "./modal-view-souscripteur-detail.component.html",
  styleUrls: ["./modal-view-souscripteur-detail.component.scss"],
})
export class ModalViewSouscripteurDetailComponent implements OnInit {
  indiceTab: number = 0;
  busyGet: Subscription;
  filiale_id: any;
  user: any = {};
  garantLibelle = "";
  currentData: any;
  modalRef: BsModalRef;

  itemGarant: any = {};
  itemsFiliale: any;
  garantData: any;
  souscripteurLibelle: any;
  souscripteurData: any;

  constructor(
    public bsModalRef: BsModalRef,
    private authService: AuthService,
    private restClient: RestClientService,
    private modalService: BsModalService
  ) {
    this.user = this.authService.getCurrentUser();
    this.filiale_id = this.user.filiale_id;
    setTimeout(() => {
      if (this.currentData) {
        this.souscripteurData = this.currentData;
        console.log("this.souscripteurData======: ", this.currentData);
      }
    }, 50);
  }

  selectedChangeValue(event: any) {
    console.log("le event selectedChangeValue", event);

    if (!event) this.indiceTab = 0;

    this.indiceTab = event;
  }

  onGoToNextTab(event) {
    this.indiceTab++;
    console.log("event: ", event);
  }

  onGetsouscripteurInfo(event) {
    console.log("event emitted onGetsouscripteurInfo: ", event);
    this.souscripteurLibelle = event.libelle;
    this.souscripteurData = event;
  }

  ngOnInit() {}
}
